import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  gridFilter: { filters: [] },
  gridSort: [],
  gridPage: { skip: 0, take: 10 },
  customFilters: [],
  data: [],
  total: 0,
};

const listZmluva = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST_ZMLUVA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_LIST_ZMLUVA_SUCCESS:
      const { res, gridFilter, gridSort, gridPage, customFilters } = action;
      const { Items, TotalRecords } = res.Data;

      return {
        ...state,
        gridFilter,
        gridSort,
        gridPage,
        customFilters,
        isLoading: false,
        data: Items,
        total: TotalRecords,
      };

    case actionTypes.GET_LIST_ZMLUVA_FAILURE:
      return _initState;

    case actionTypes.UPDATE_CUSTOM_FILTERS_ZMLUVY:
      return { ...state, customFilters: action.customFilters };

    default:
      return state;
  }
};

export default listZmluva;
